import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export const deTargetDashboardReducer = (
  state = initialState.deTargetDashboard,
  action
) => {
  switch (action.type) {
    case types.RESET_DE_STATE: {
      return {
        ...state,
        ...initialState.deTargetDashboard,
      };
    }
    case types.RESET_QUERY_ON_SEARCH_SORT: {
      return {
        ...state,
        definition: {
          ...state.definition,
          response: {
            totalPages: 1,
            currentPage: 1,
            hasMorePages: false,
            data: [],
          },
        },
      };
    }

    case types.SET_DE_CT_TABLE_QUERY: {
      return {
        ...state,
        definition: {
          ...state.definition,
          query: action.query,
          response: {
            ...state.definition.response,
            hasMorePages: false,
          },
        },
      };
    }

    case types.GET_DE_DEFINITION_REQUEST: {
      return {
        ...state,
        definition: {
          ...state.definition,
          loading: true,
          error: false,
        },
      };
    }
    case types.GET_DE_DEFINITION_FAILURE: {
      return {
        ...state,
        definition: {
          ...state.definition,
          loading: false,
          error: true,
        },
      };
    }
    case types.GET_DE_DEFINITION_SUCCESS: {
      return {
        ...state,
        definition: {
          ...state.definition,
          loading: false,
          error: false,
          response: action.response,
          hasDefinition:
            state.definition.hasDefinition || action.response.data.length > 0,
        },
      };
    }
    case types.SET_DELETE_DE_TARGET:{
      return {
        ...state,
        definition: {
          ...state.definition,
          loading: false,
          error: false,
          response: action.response,
          hasDefinition:
            state.definition.hasDefinition || action.response.data.length > 0,
        },
      };
    }
    default:
      return state;
  }
};
